<template>
  <AuthLayout center>
    <v-card flat class="w-100 pb-sm-16 pt-16" slot="form" >
      <v-toolbar flat>
        <v-spacer />
        <h1 class="text-center">Forgot Password</h1>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-form ref="forgotPasswordForm">
          <v-text-field
            outlined
            label="Email"
            type="email"
            placeholder="Enter your email"
            v-model="email"
            :rules="emailRules"
          />
          <v-row no-gutters align="center">
            <v-col cols="auto">
              <p class="mb-0">
                <small @click="$router.push('/login')" class="font-weight-bold">
                  Remember password?
                </small>
              </p>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-btn
                block
                color="primary"
                @click="forgotPassword"
                :loading="isSubmitting"
                :disabled="isSubmitting"
              >
                Reset
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-toolbar flat class="hidden-sm-and-up">
        <v-spacer />
        <router-link to="/">
          <img
            alt="logo"
            :src="require('@/assets/img/logo-black.png')"
            width="100"
          />
        </router-link>
        <v-spacer />
      </v-toolbar>
    </v-card>
    <AuthLeftContent slot="content" />
  </AuthLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AuthLayout from '@/components/auth/AuthLayout'
import AuthLeftContent from '@/components/auth/AuthLeftContent'
import validationRules from '@/validation-rules'

export default {
  components: {
    AuthLayout,
    AuthLeftContent
  },
  data () {
    return {
      isSubmitting: false,
      email: '',
      ...validationRules
    }
  },
  computed: mapGetters(['user', 'resetPassword']),
  methods: {
    ...mapActions(['toggleDialog', 'getResetPassword']),
    async forgotPassword () {
      this.isSubmitting = true
      const self = this
      if (self.$refs.forgotPasswordForm.validate()) {
        await this.getResetPassword({ email: self.email })
        this.isSubmitting = false
        if (this.resetPassword) {
          this.toggleDialog({
            status: true,
            title: 'Success!',
            message: 'An email has been set to your inbox with the reset password link.'
          })
        }
      }
    }
  }
}
</script>
